module.exports = __webpack_public_path__ + "img/cloth_g3_item-16.85280af4.svg";